import React from 'react'
import { Button, Container } from 'react-bootstrap'
import { Link } from 'react-router-dom'

function CabinetBusiness({ data }) {
    
    return (
        <Container className="wrapper my-5" >
            <div style={{ margin: '0 auto', width: 'fit-content' }}>
                <h3 className='my-4'>
                    Особистий кабінет
                </h3>
                <ol style={{ listStyleType: 'none', textAlign: 'left', lineHeight: "30px" }}>
                    {/* <li><span style={{ fontWeight: 'bold' }}>Логін:</span>&nbsp;{data.username}</li> */}
                    <li><span style={{ fontWeight: 'bold' }}>Email:</span>&nbsp;{data.email}</li>
                    <li><span style={{ fontWeight: 'bold' }}>Ім'я контактної особи:</span>&nbsp;{data.firstName} </li>
                    <li><span style={{ fontWeight: 'bold' }}>Телефон:</span>&nbsp;{data.phone}</li>
                    <li><span style={{ fontWeight: 'bold' }}>Область з якої переїхали:</span>&nbsp;{data.regionFrom}</li>
                    <li><span style={{ fontWeight: 'bold' }}>Податковий номер платника податків (ФОПа):</span>&nbsp;{data.numberFOP}</li>
                    <li><span style={{ fontWeight: 'bold' }}>Код ЄДРПОУ:</span>&nbsp;{data.codeEDRPOU}</li>
                    <li><span style={{ fontWeight: 'bold' }}>Назва компанії:</span>&nbsp;{data.companyName}</li>
                    <li><span style={{ fontWeight: 'bold' }}>Чи користувались грантовою підтримкою бізнесу?</span>&nbsp;{data.grantSupport}</li>
                    <li><span style={{ fontWeight: 'bold' }}>Необхідна підтримка:</span>&nbsp;{data.supportType}</li>
                </ol>
            </div>
            <Link to={`/profile/update/${data.id}`}>
                <Button
                    //className='btn-disabled'

                    //  style={{ backgroundColor: "#78BEB3", borderRadius: "0", borderColor: "#2bd191be", color: "#fff" }} 
                    className='btn-rout my-3'
                >
                    Редагувати дані
                </Button>
            </Link>
        </Container>
    )
}

export default CabinetBusiness
